import { render, staticRenderFns } from "./rows-editor.vue?vue&type=template&id=99e99dee&scoped=true&"
import script from "./rows-editor.vue?vue&type=script&lang=js&"
export * from "./rows-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99e99dee",
  null
  
)

export default component.exports